var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00750732 11.25C0.00750732 9.26088 0.797684 7.35322 2.20421 5.9467C3.61073 4.54018 5.51838 3.75 7.50751 3.75H52.5075C54.4966 3.75 56.4043 4.54018 57.8108 5.9467C59.2173 7.35322 60.0075 9.26088 60.0075 11.25V48.75C60.0075 50.7391 59.2173 52.6468 57.8108 54.0533C56.4043 55.4598 54.4966 56.25 52.5075 56.25H7.50751C5.51838 56.25 3.61073 55.4598 2.20421 54.0533C0.797684 52.6468 0.00750732 50.7391 0.00750732 48.75V11.25V11.25ZM3.75751 45V48.75C3.75751 49.7446 4.1526 50.6984 4.85586 51.4016C5.55912 52.1049 6.51295 52.5 7.50751 52.5H52.5075C53.5021 52.5 54.4559 52.1049 55.1592 51.4016C55.8624 50.6984 56.2575 49.7446 56.2575 48.75V35.625L42.0938 28.3237C41.7421 28.1476 41.3439 28.0865 40.9556 28.1491C40.5673 28.2117 40.2085 28.3948 39.93 28.6725L26.0175 42.585L16.0425 35.94C15.6824 35.7002 15.2504 35.5924 14.8198 35.6348C14.3892 35.6771 13.9865 35.8671 13.68 36.1725L3.75751 45ZM22.5075 20.625C22.5075 19.1332 21.9149 17.7024 20.86 16.6475C19.8051 15.5926 18.3744 15 16.8825 15C15.3907 15 13.9599 15.5926 12.905 16.6475C11.8501 17.7024 11.2575 19.1332 11.2575 20.625C11.2575 22.1168 11.8501 23.5476 12.905 24.6025C13.9599 25.6574 15.3907 26.25 16.8825 26.25C18.3744 26.25 19.8051 25.6574 20.86 24.6025C21.9149 23.5476 22.5075 22.1168 22.5075 20.625Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImg);
export default __webpack_public_path__ + "static/media/empty_img.c7a7a41916c947d6ca98f4a38eff52dd.svg";
export { ForwardRef as ReactComponent };